import * as _ from 'lodash';
import * as React from 'react';
import { RotateIcon, MenuListItemContainer, IconContainer,IconErrorSyncContainer, ToolTipContainer,ToolTipLabel, LabelContainer } from './styles';
import { Link, useLocation } from 'react-router-dom';
import { Label } from '../../common/baseComponents';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../store/types';
import { Menu } from './state/types';
import { ArrowLeftIcon } from 'common/icons/arrowLeftIcon';
import  * as IconsMenu from 'common/icons/menuIcons';
import { ReactComponent as IconLock } from 'common/images/lock-menu.svg'
import IconErrorSync from 'common/images/icon-error-sync.svg'

export interface MenuListItemProps {
    menuItem: Menu;
    isSelected: boolean;
    handleSelectItem: (selected: Menu) => void;
    hasChildren?: boolean,
    isChildren?: boolean,
    status?: string,
    hasError?:boolean
    collapse?: boolean;
    onOver?: (over: boolean) => void;
}


const MenuListItem = (props: MenuListItemProps) => {
    const location = useLocation()
    
    const rootProps = useSelector((rootState: RootState) => {
        return {
            engineDealer: rootState.dealers.enginedealer.enginedealer,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            connect: rootState.dealers.connectByLabel.connect?.connected,
            industry: rootState.dealers.dealer.industry

        }
    }, shallowEqual);

    const isLocked = React.useMemo(()=> {
        return props.menuItem.visible? !props.menuItem.visible.find(f=>f.status == props.status)?.value:false
    }, [props.status, rootProps.selectedDealer?.siteType, rootProps.connect])
    
    

    
    const isVisible = React.useMemo(() => {
        return props.menuItem.internalName.toLowerCase() == "edit" && rootProps.selectedDealer?.siteType?(rootProps.selectedDealer?.siteType.toLowerCase()!="group" && rootProps.selectedDealer?.siteType && rootProps.selectedDealer?.siteType.toLowerCase()!="preowned"):true    
    }, [rootProps.selectedDealer?.siteType]);
   
    const isHideIndustry =  React.useMemo(() => {        
        if (props.menuItem.hideIndustry)
        {
            if (rootProps.industry)
                return props.menuItem.hideIndustry.indexOf(rootProps.industry)>=0
            return true;
        }
        return false;
    }, [rootProps.industry, rootProps.selectedDealer]);

    const toLocation = React.useMemo(() => {
        return {
            pathname: props.menuItem.url?props.menuItem.url.find(f=> f.status ==  props.status )?.path:"",
            search: location.search
        }
    }, [location.search, props.status]);

    const linkStyle = {
        textDecoration: 'none',
        //pointerEvents: rootProps.engineDealer?'auto':'none'
    };
    
    if (isVisible && !isHideIndustry)
    {

    const Icon = props.menuItem.icon ?  IconsMenu[props.menuItem.icon] : IconsMenu['location'];

    
    return (
        <>
        <Link to={rootProps.selectedDealer?.id?toLocation:''} style={linkStyle}>
            <MenuListItemContainer
                id={props.menuItem.internalName}
                isSelected={props.isSelected && !props.hasChildren}
                isLocked ={isLocked}
                isChildren={props.isChildren }
                onClick={handleSelection}
                collapse={props.collapse}
                onMouseOver={() =>  (props.onOver && !isLocked) && props.onOver(props.menuItem.internalName ==="edit")}
                onClickCapture={() =>  (props.onOver && !isLocked) && props.onOver(false)}
            >
                { !props.isChildren && <IconContainer> 
                    {(isLocked)
                    ?<IconLock></IconLock>
                    : <Icon/>}
                </IconContainer>}
                <LabelContainer>
                <Label style={props.isChildren ? {"marginLeft": "10px"}:{} }>
                    {_.startCase(props.menuItem.displayName)}
                    {
                        props.hasError && 
                        <IconErrorSyncContainer>
                            <img src={IconErrorSync}/>
                            <ToolTipContainer>
                                <ToolTipLabel>
                                Some errors happened during the 
                                last sync. You can see the error 
                                details next to the appropriate 
                                fields when you go to this page.
                                </ToolTipLabel>
                            </ToolTipContainer>
                        </IconErrorSyncContainer>
                    }
                </Label>
                </LabelContainer>
                
                {
                    props.hasChildren && 
                    <RotateIcon isSelected={props.isSelected}>
                        <ArrowLeftIcon />
                    </RotateIcon>
                }
                
            </MenuListItemContainer>
               
        </Link>
       
        </>
        
    );

    }
    else
    {
        return (
            <></>

        );
    }
    
   

    function handleSelection(event: { currentTarget: { id: string } }) {
        props.handleSelectItem(props.menuItem);
    }
}

export default MenuListItem;
